import { NOTIFICATION_TYPE, useNotificationStore } from '@/stores/notification'

class NotificationService {
    /**
     * @description Fire Confirmation Sweetalert Modal
     * @param message | String | message you to display
     * @param confirm | String | text of the button to confirm
     * @param cancel | String | text of the button to cancel
     * @returns {Promise}
     */
    static async notifyUserConfirmation(
        message = '',
        confirm = 'Submit',
        cancel = 'Cancel'
    ) {
        const notificationStore = useNotificationStore()

        return new Promise((resolve, reject) => {
            function onConfirm(result) {
                resolve(result)
            }

            function onClose() {
                reject('closed')
            }

            notificationStore.showNotification({
                type: NOTIFICATION_TYPE.WARNING,
                asToast: false,
                content: message,
                submitText: confirm,
                cancelText: cancel,
                onConfirm: onConfirm,
                onClose: onClose,
            })
        })
    }

    /**
     * @description Fire Error Sweetalert Modal
     * @returns {Promise}
     * @param message
     */
    static async notifyUserError(message = '', toast = false) {
        const notificationStore = useNotificationStore()

        return new Promise((resolve) => {
            function onConfirm(result) {
                resolve(result)
            }

            function onClose(result) {
                resolve(result)
            }

            notificationStore.showNotification({
                type: NOTIFICATION_TYPE.ERROR,
                asToast: toast,
                content: message,
                submitText: 'Try again!',
                onConfirm: onConfirm,
                onClose: onClose,
            })
        })
    }

    /**
     * @description Fire Error Sweetalert Modal
     * @param errors
     * @returns {Promise}
     */
    static async notifyUserErrors(errors = []) {
        if (typeof errors === 'object') {
            errors = Object.values(errors)
        }

        const content =
            errors.length > 1
                ? errors
                      .map((error) => `<li key=${error}>${error}</li>`)
                      .join('')
                : errors[0]

        const notificationStore = useNotificationStore()

        return new Promise((resolve) => {
            function onConfirm(result) {
                resolve(result)
            }

            function onClose(result) {
                resolve(result)
            }

            notificationStore.showNotification({
                type: NOTIFICATION_TYPE.ERROR,
                asToast: false,
                content: content,
                submitText: 'Try again!',
                onConfirm: onConfirm,
                onClose: onClose,
            })
        })
    }

    /**
     * @description Fire Error Sweetalert Modal
     * @returns {Promise}
     * @param message
     */
    static async notifyUserSuccess(message = '') {
        const notificationStore = useNotificationStore()
        return new Promise((resolve) => {
            function onConfirm(result) {
                resolve(result)
            }

            function onClose(result) {
                resolve(result)
            }

            notificationStore.showNotification({
                type: NOTIFICATION_TYPE.SUCCESS,
                asToast: true,
                content: message,
                onConfirm: onConfirm,
                onClose: onClose,
            })
        })
    }

    /**
     * @description Fire Error Sweetalert Modal
     * @returns {Promise}
     * @param message
     */
    static async notifyUserInfo(message = '') {
        const notificationStore = useNotificationStore()
        return new Promise((resolve) => {
            function onConfirm(result) {
                resolve(result)
            }

            function onClose(result) {
                resolve(result)
            }

            notificationStore.showNotification({
                type: NOTIFICATION_TYPE.INFO,
                asToast: true,
                content: message,
                onConfirm: onConfirm,
                onClose: onClose,
            })
        })
    }

    /**
     * @description Fire Error Sweetalert Modal
     * @returns {Promise}
     * @param message
     */
    static async notifyUserWarning(message = '') {
        const notificationStore = useNotificationStore()
        return new Promise((resolve) => {
            function onConfirm(result) {
                resolve(result)
            }

            function onClose(result) {
                resolve(result)
            }

            notificationStore.showNotification({
                type: NOTIFICATION_TYPE.WARNING,
                asToast: true,
                content: message,
                onConfirm: onConfirm,
                onClose: onClose,
            })
        })
    }
}

export default NotificationService
